import { Injectable } from '@angular/core';
import { IColumnPickerItem } from '../utils/column-layout';

export interface IColumnLayoutApi {
  reset: () => void;
  listColumns: () => IColumnPickerItem[];
  setColumnVisible: (key: string, visible: boolean) => void;
}

@Injectable({
  providedIn: 'root'
})
export class ColumnLayoutRegistry {
  private readonly instances = new Map<string, IColumnLayoutApi>();

  register(id: string, api: IColumnLayoutApi): void {
    this.instances.set(id, api);
  }

  unregister(id: string, api: IColumnLayoutApi): void {
    if (this.instances.get(id) === api) {
      this.instances.delete(id);
    }
  }

  reset(id: string): void {
    this.instances.get(id)?.reset();
  }

  listColumns(id: string): IColumnPickerItem[] {
    return this.instances.get(id)?.listColumns() ?? [];
  }

  setColumnVisible(id: string, key: string, visible: boolean): void {
    this.instances.get(id)?.setColumnVisible(key, visible);
  }

  has(id: string): boolean {
    return this.instances.has(id);
  }
}
